import React, { useEffect } from 'react';

import ErrorBoundary from '../contexts/ErrorBoundary';
import { BannerProvider } from '../contexts/BannerContext';
import {QUALTRICS_ORIGIN} from "../constants";


export const SurveyFeedback = () => {

  useEffect(() => {
    const payload = {
      type: 'QUALTRICS_DATA_SYNC',
      businessType: window.digitalData?.site?.businessType === 'b2b' ? 'b2b' : 'b2c',
    };

    const sendDataToQualtrics = (iframe) => {
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(payload, QUALTRICS_ORIGIN);
      }
    };

    const container = document.getElementById('epcfeedback');
    if (!container) return undefined;

    const observer = new MutationObserver(() => {
      const iframe = container.querySelector('iframe');
      if (iframe) {
        observer.disconnect();
        iframe.addEventListener('load', () => sendDataToQualtrics(iframe));
      }
    });
    observer.observe(container, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      let containerWidth = document.getElementById('epcfeedbackContainer').offsetWidth;
      let compSize = 0.8;
      const compSizeWidth = (containerWidth * compSize) + 'px';
      const centerStyle = '0 auto';
      document.querySelector('#epcfeedback > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div > div').style.width = compSizeWidth;
      document.querySelector('#epcfeedback > div > div > div > div').style.width = compSizeWidth;
      document.querySelector('.QSIUserDefinedHTML').style.margin = centerStyle;
    };

    const resizeObserver = new MutationObserver(handleResize);
    const surveyContainer = document.getElementById('epcfeedback');
    const observerOptions = { attributes: false, childList: true, subtree: false };
    resizeObserver.observe(surveyContainer, observerOptions);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BannerProvider>
        <div id="epcfeedbackContainer" className="sui-pt-8 sui-overflow-hidden sui-text-center">
          <div id="epcfeedback" className="sui-z-0 sui-relative !sui-max-w-full" data-testid="feedbackTest" />
        </div>
      </BannerProvider>
    </ErrorBoundary>
  );
};

export default SurveyFeedback;
